import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ScrollToTop from '../../components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import ClassTypesSection from './components/ClassTypesSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import PacotesBox from '@/components/feature/PacotesBox';
import NossosFones from '@/components/feature/NossosFones';

export default function AulaSilenciosaPage() {
  useEffect(() => {
    document.title = 'Aula Silenciosa | Fones Sem Fio para Ensino Multilíngue — STIB';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Aula Silenciosa para escolas de idiomas, academias fitness, treinamentos corporativos e workshops no Brasil. Até 10 aulas simultâneas no mesmo espaço com fones sem fio. +200 instituições atendidas · STIB (11) 91777-6227'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://stibpalestrasilenciosasp.com.br/aula-silenciosa');

    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          '@id': `${siteUrl}/aula-silenciosa#service`,
          name: 'Aula Silenciosa — Tecnologia de Áudio Sem Fio para Ensino',
          alternateName: ['Silent Classroom Brasil', 'Aula com Fones Sem Fio', 'Ensino Multilíngue Simultâneo'],
          description:
            'Aula Silenciosa profissional para escolas de idiomas, academias, treinamentos corporativos, feiras educacionais e workshops em todo o Brasil. Até 10 aulas simultâneas no mesmo espaço com fones sem fio, zero interferência sonora.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'STIB — Palestra Silenciosa Brasil',
            url: siteUrl,
            telephone: '+55-11-91777-6227',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'São Paulo',
              addressRegion: 'SP',
              addressCountry: 'BR',
            },
          },
          serviceType: 'Locação de Equipamento de Áudio Sem Fio para Ensino',
          areaServed: { '@type': 'Country', name: 'Brasil' },
          offers: {
            '@type': 'Offer',
            availability: 'https://schema.org/InStock',
            areaServed: 'BR',
            priceCurrency: 'BRL',
          },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Serviços', item: `${siteUrl}/servicos` },
            { '@type': 'ListItem', position: 3, name: 'Aula Silenciosa', item: `${siteUrl}/aula-silenciosa` },
          ],
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Qual o número mínimo e máximo de alunos para aula silenciosa?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Atendemos turmas a partir de 10 alunos. O teto atual é de 1.500 fones simultâneos.',
              },
            },
            {
              '@type': 'Question',
              name: 'Quantos canais (aulas simultâneas) o sistema suporta?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Até 10 canais independentes — ou seja, até 10 instrutores diferentes conduzindo aulas simultâneas no mesmo espaço físico.',
              },
            },
            {
              '@type': 'Question',
              name: 'A STIB atende fora de São Paulo?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Sim. Atendemos todo o Brasil — São Paulo, Rio de Janeiro, Brasília, Belo Horizonte, Curitiba, Porto Alegre, Recife, Fortaleza, Salvador e demais cidades.',
              },
            },
          ],
        },
      ],
    };

    const existing = document.getElementById('aula-silenciosa-schema');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'aula-silenciosa-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('aula-silenciosa-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingCTA />
      <ScrollToTop />
      <main>
        <HeroSection />
        <WhatIsSection />
        <ClassTypesSection />
        <HowItWorksSection />
        <BenefitsSection />
        <TestimonialsSection />
        <FAQSection />
      <NossosFones />
      <PacotesBox texto="Para aulas fixas na grade (academias, estúdios, escolas e treinamentos), o pacote mensal mantém os fones reservados toda semana, com valor fechado e previsível, em vez de contratar aula por aula." />
      </main>
      <Footer />
    </div>
  );
}